import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';

function CrossSellLightBoxContent(props) {
    const {
        data,
        onClose
    } = props;

    return (
        <div className="cross-sell-light-box__content cross-sell-light-box-content">
            <p
                className={`cross-sell-light-box-content__why-alignment ${data && data.fromEuLabels ? 'eu-labels-content-container' : ''}`}
                dangerouslySetInnerHTML={toDangerousReactHtml((data && (data.lightContent || data.description)))}
            />

            {props.error && props.error.invalid && <p
                name="error-cross-sell"
                className="cross-sell-light-box-content__why-alignment floating-label-element__hint--invalid"
                style={{ border: 'none' }}
                dangerouslySetInnerHTML={toDangerousReactHtml(props.error.invalidMessage)}
                />
            }
        </div>
    );
}

CrossSellLightBoxContent.propTypes = {
    expanded: PropTypes.bool.isRequired,
    LightBoxVisible: PropTypes.bool.isRequired,
    error: PropTypes.object,
    onExpand: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { CrossSellLightBoxContent };
